import { FunctionComponent, lazy, Suspense, useEffect, useRef } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../../../components/formulario/tableStyled";
import LoadingGif from "../../../../../../components/loading";
import { UseServicesEvent } from "../../../context/servicesContext";

const Rows = lazy(() => import('../rows'));

interface TabelaListaEventosBatismoProps {

}

const TabelaListaEventosBatismo: FunctionComponent<TabelaListaEventosBatismoProps> = () => {

  const { nextPagina } = UseServicesEvent();

  const devRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (devRef.current) {
      devRef.current.addEventListener('scroll', (e: any) => {
        if (e.target?.scrollTop >= (e.target.scrollHeight - (e.target.clientHeight + 60))) {
          nextPagina()
        }
      })
    }
  }, [devRef])

  return (<>

        <Tabler>
          {/*@ts-ignore*/}
          <CorpoTable ref={devRef}>
            <Tabela>
              <>
                <TabelaCabeca>
                  <tr>
                    {
                      ['Id', 'Sede', 'Evento', 'Cidade', 'Inicio', 'Termino', 'Ativo', 'Permite Inscrição?']?.map(
                        res => <th>{res}</th>
                      )
                    }
                    <th></th>
                  </tr>
                </TabelaCabeca>
                <TabelaCorpo >
                  <Suspense fallback={<LoadingGif/>}>
                    <Rows />
                  </Suspense>
                </TabelaCorpo>
              </>
            </Tabela>
          </CorpoTable>
        </Tabler>
  </>);
}

export default TabelaListaEventosBatismo;
